import { v2ApiClient } from './apiClient';

export const paymentService = {
  async payClassFee(classId, payload) {
    const response = await v2ApiClient.post(`/lms/class/${classId}/payment`, payload);
    if (response && response.isSuccessful) {
      return response;
    }
    throw new Error(response?.message || 'Payment failed');
  },

  async validatePromoCode({ code, classId, studentId }) {
    const params = new URLSearchParams();
    if (code) params.append('code', code);
    if (classId) params.append('classId', classId);
    if (studentId) params.append('studentId', studentId);

    const response = await v2ApiClient.get(`/lms/promo-code/validate?${params.toString()}`);
    if (response && response.isSuccessful) {
      return response;
    }
    throw new Error(response?.message || 'Promo code validation failed');
  }
};

export default paymentService;
